const rbtm = {
  alarmType: 'Alarm type',
  closeAlarm: 'Close alarm',
  closeOpenSar: 'Close and open SAR',
  currencyCode: 'Currency code',
  evaluationDate: 'Evaluation date',
  evaluationNote: 'Evaluation note',
  manageScenarios: 'Manage scenarios',
  operationDate: 'Operation date',
  operator: 'Operator',
  rbtm: 'Rule based transaction monitor',
  rule: 'Rule',
  score: 'Score',
  confirmOpenSar: 'Are you sure you want to close the alarm and open a SAR?',
  suspiciousTransactions: 'Suspicious transactions',
  transactionDetailForEvaluation: 'Transaction detail for evaluation',
  transactionParties: 'Transaction parties',
};

export default rbtm;
